import { atom, useRecoilState, useResetRecoilState } from 'recoil';
import { AccountInfo } from 'types';
import { localStorageEffect } from './effects';

const key = 'impersonateAccount';

export const impersonateAccount = atom<AccountInfo>({
    key,
    default: undefined,
    effects: [
        localStorageEffect(key)
    ]
});

export const useImpersonateAccount = () => useRecoilState(impersonateAccount);

export const useResetImpersonateAccount = () => useResetRecoilState(impersonateAccount);